module.exports = __webpack_public_path__ + "static/media/paralax1.501780e6.jpg";